export default __webpack_public_path__ + "static/the-differance-is-clear-video-fr-a85c207818b3732caaf17c9c68f4db14.mp4";